import { useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import classNames from "classnames";
import { useWindowSize } from "react-use";

const tabs: { url: string; text: string }[] = [
  {
    url: "/about",
    text: "About Sifted",
  },
  {
    url: "/advertising",
    text: "Advertising",
  },
  {
    url: "/pitch-your-story",
    text: "Pitch Your Story",
  },
  {
    url: "/careers",
    text: "Careers",
  },
  {
    url: "/contact-us",
    text: "Contact Us",
  },
];

export default function UtilityPageNav() {
  const { pathname } = useRouter();
  const [showGradient, setShowGradient] = useState<boolean>(true);
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const { width } = useWindowSize();

  const handleScroll = () => {
    if (!scrollRef.current) return;
    const container = scrollRef.current;
    const scrollableWidth = container.scrollWidth - container.clientWidth;
    const scrollPosition = container.scrollLeft;

    if (scrollPosition > scrollableWidth - 10 && showGradient) {
      setShowGradient(false);
    } else if (scrollPosition <= scrollableWidth - 10 && !showGradient) {
      setShowGradient(true);
    }
  };

  useEffect(() => {
    handleScroll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [width]);

  return (
    <aside className="relative flex-shrink-0 md:flex-row lg:pt-[1.25rem]">
      <ul className="top-20 hidden w-[200px] text-[18px] lg:sticky lg:mr-5 lg:block lg:min-w-[200px] lg:flex-col">
        {tabs.map((tab, i) => {
          return (
            <li
              key={i}
              className={classNames("px-[6px] py-[10px] text-[1.125rem]", {
                "text-[#707073]": pathname !== tab.url,
                "text-black-rock font-bold": pathname === tab.url,
              })}
            >
              <a href={tab.url}>{tab.text}</a>
            </li>
          );
        })}
      </ul>

      <div className="w-100 lg:hidden">
        <div
          ref={scrollRef}
          onScroll={handleScroll}
          className="no-scrollbar flex flex-nowrap overflow-x-auto overflow-y-hidden border-b border-[#CACACC]"
        >
          {tabs.map((tab, i) => {
            return (
              <a key={i} href={tab.url}>
                <div
                  className={classNames(
                    "flex h-[53px] items-center whitespace-nowrap px-3 text-[18px]",
                    {
                      "text-[#707073]": pathname !== tab.url,
                      "border-black-rock text-black-rock border-b-[3px] font-bold":
                        pathname === tab.url,
                    }
                  )}
                >
                  <span
                    className={classNames({
                      "translate-y-[1.5px]": pathname === tab.url,
                    })}
                  >
                    {tab.text}
                  </span>
                </div>
              </a>
            );
          })}

          <div
            className={classNames(
              "pointer-events-none absolute right-0 h-100 w-[80px] bg-gradient-to-r from-[#f6f6f600] to-[#F6F6F6] transition-opacity md:hidden",
              {
                "opacity-100": showGradient,
                "opacity-0": !showGradient,
              }
            )}
          ></div>
        </div>
      </div>
    </aside>
  );
}
